import Banner from './Banner'

export default Banner



// WEBPACK FOOTER //
// ./src/components/shared/elements/Banner/index.js